module.exports = __webpack_public_path__ + "img/home.1d42c737.png";